import { HeaderNavBar } from '@/components/content/Header/parts/NavBar';
import { Box } from '@mui/material';
import { FC, Fragment } from 'react';
import { ID } from '@/data/types/Basic';
import { Promotions } from '@/components/content/Header/parts/Promotions';
import { HeaderNavBarMobile } from '@/components/content/Header/parts/HeaderNavBarMobile';
import useMediaQuery from '@mui/material/useMediaQuery';
import { headerContainerSX } from '@/components/content/Header/styles/container';
import { LoadingBar } from '@/components/content/Header/parts/LoadingBar';
import { useHeaderVisibility } from '@/components/content/Header/hooks/useHeaderVisibility';
import { useServerSideRuntime } from '@/data/context/origin';

export const useMobileHeaderQuery = () => {
	const { isMobile } = useServerSideRuntime();
	return useMediaQuery('(max-width:1100px)', { defaultMatches: isMobile });
};

export const Header: FC<{
	id: ID;
}> = ({ id }) => {
	const isMobile = useMobileHeaderQuery();
	const visible = useHeaderVisibility();

	return (
		<Fragment>
			<Box id="header-top" />
			<LoadingBar />
			<Box sx={{ position: 'relative', zIndex: 9001 }}>
				<Promotions />
			</Box>
			<Box component="header" sx={headerContainerSX(visible)} id="header">
				{isMobile ? <HeaderNavBarMobile id={id} /> : <HeaderNavBar />}
				<Box id="header-bottom" />
			</Box>
		</Fragment>
	);
};
